import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { Modal } from 'bootstrap'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const parent = $('.pt-services__posts')
if (parent.length) {
  iso = new Isotope('.pt-services__posts', {
    itemSelector: '.feed-service',
    percentPosition: true,
    masonry: {
      columnWidth: '.pt-services__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })

  $('.service-filter').on('click', function () {
    const $this = $(this)
    const parent = $('.header-with-search__big-terms')
    let curParent = $this.parent()
    const allPrent = parent.find('.feed-taxonomy-business-area')
    const val = $this.parent().attr('data-id') * 1

    if (window.matchMedia('(max-width: 575.98px)').matches) {
      if (parent.hasClass('filtered')) {
        iso.arrange({ filter: '*' })
        allPrent.hide()
        parent.removeClass('filtered')
        $this.removeClass('active')
        return
      }
    }

    iso.arrange({
      filter: function () {
        const service = $(this)

        if (service.hasClass('pt-services__sizer')) {
          return false
        }

        const attr = service.attr('data-business-areas')
        const businessAreas = attr.includes(',') ? attr.split(',') : [attr]
        const newBusinessAreas = businessAreas.map(Number)

        return newBusinessAreas.includes(val)
      },
    })

    if (window.matchMedia('(max-width: 575.98px)').matches) {
      allPrent.not(curParent).hide()
      curParent.show()
      parent.addClass('filtered')
      $this.addClass('active')
      return
    }

    allPrent.not(curParent).hide()

    if ($this.hasClass('active')) {
      iso.arrange({ filter: '*' })
      $this.removeClass('active')
      allPrent.show()
      $('.header-with-search__back-wrapper').hide()
      return
    }

    $this.addClass('active')
    $('.header-with-search__back-wrapper').show()
  })
}

$('.header-with-search__back').on('click', function () {
  $(this).parent().hide()
  $('.feed-taxonomy-business-area').show()
  $('.service-filter').removeClass('active')
  iso.arrange({ filter: '*' })
})

const search = $('.service-search').keyup(
  debounce(function () {
    const regex = new RegExp(search.val(), 'gi')

    iso.arrange({
      filter: function () {
        const text = getTextNodesIn($(this)[0])
        return regex ? text.match(regex) : true
      },
    })
  }, 200)
)

$('.modal-service-filter').on('click', function () {
  const index = $(this).parent().index()
  const parent = $('.header-with-search__big-terms')
  parent.find('.service-filter').eq(index).click()
  const modal = Modal.getOrCreateInstance(
    document.querySelector('.filter-modal--service')
  )

  modal.hide()
})

const defaultFilterEl = $('.pt-services .header-with-search__big-terms')
if (defaultFilterEl.length) {
  const defaultFilter = defaultFilterEl.attr('data-default')
  if (defaultFilter) {
    const parent = $('.header-with-search__big-terms')
    const cur = parent.find(
      `.feed-taxonomy-business-area[data-slug=${defaultFilter}] > div`
    )
    cur.click()
  }
}
